import classNames from 'classnames';
import * as React from 'react';
import { useState } from 'react';
import { FieldValues, RegisterOptions, UseFormRegister } from 'react-hook-form';
import styles from './BaseInput.module.scss';

export type FormRegisterType = {
	register: UseFormRegister<FieldValues>;
	fieldName: string;
	options?: RegisterOptions<FieldValues, string>;
};

export interface BaseInputProps extends React.ComponentProps<'input'> {
	className?: string;
	textLeft?: boolean;
	hasErrors?: boolean;
	disabled?: boolean;
	onChange?: React.ChangeEventHandler<HTMLInputElement>;
	value?: number | string;
	defaultValue?: string | number;
	formRegister?: FormRegisterType;
	type?: string;
	inputMode?: 'numeric'
}

export const BaseInput: React.FC<BaseInputProps> = ({
	className,
	textLeft = false,
	hasErrors = false,
	disabled = false,
	value,
	defaultValue,
	onChange,
	formRegister,
	...baseInputProps
}: BaseInputProps) => {
	const [inputValue, setInputValue] = useState(defaultValue);
	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setInputValue(e.target.value);
		onChange && onChange(e);
	};
	return (
		<input
			className={classNames(
				styles.BaseInput,
				className,
				textLeft ? '' : styles.BaseInput___textRight,
				hasErrors ? styles.BaseInput___isInvalid : '',
				disabled ? styles.BaseInput___disabled : '',
			)}
			disabled={disabled}
			value={value ?? inputValue}
			{...formRegister?.register(formRegister.fieldName, formRegister.options)}
			onChange={handleChange}
			{...baseInputProps}
		/>
	);
};
